import { render, staticRenderFns } from "./auditFlowConfiguration.vue?vue&type=template&id=48fa2bab&scoped=true&"
import script from "./auditFlowConfiguration.vue?vue&type=script&lang=ts&"
export * from "./auditFlowConfiguration.vue?vue&type=script&lang=ts&"
import style0 from "./auditFlowConfiguration.vue?vue&type=style&index=0&id=48fa2bab&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fa2bab",
  null
  
)

export default component.exports